import { CreditCardIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";
import { buildCrudPermissions, permissionId } from "../../shared/featureFactories";

export const PaymentsFeature: FeatureMetadata = {
  id: "payments",
  moduleName: "feesFinance",
  guardianNavigation: {
    label: "Fees & Payments",
    order: 6,
    permission: permissionId("FeeFinance", "OnlinePayments", "pay"),
  },
  navigation: {
    label: "Payments",
    path: "/payments",
    icon: CreditCardIcon,
    order: 1,
  },
  route: {
    path: "/payments",
    element: lazy(() => import("./pages/Payments")),
  },
  permissions: buildCrudPermissions("FeeFinance", "FeeCollection", {
    create: permissionId("FeeFinance", "FeeCollection", "collect"),
    edit: permissionId("FeeFinance", "FeeCollection", "collect"),
    delete: permissionId("FeeFinance", "FeeCollection", "cancel"),
  }),
  readiness: "live",
};
